import React, { useState, useEffect } from 'react';
import { translation } from 'helpers/utilsHelper.js';
import IonRangeSlider from 'react-ion-slider';
import ModalOpacity from 'ModalOpacity.js';
import useToggle from 'UseToggle.js';
import { 
    fetchCashoutNowAmount,
    cashoutFullMarkForWithdraw,
    cashoutPartialMarkForWithdraw
} from 'accountBetHistoryActions.js';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import S from 'StyledCashoutForm.js';

let CashoutForm = ({slipId, maxCashoutAmountInit, fetchCashoutNowAmount, cashoutFullMarkForWithdraw, cashoutPartialMarkForWithdraw}) => {

    const [step, setNextStep] = useState(1);
    const [cashoutMaxAmount] = useState(maxCashoutAmountInit);
    const [cashoutAmount, setCashoutAmount] = useState(maxCashoutAmountInit);
    const [showConfirmationModal, toggleShowConfirmationModal] = useToggle(false);
    const [betSlipId] = useState(slipId);
    const [cashoutCode, setCashoutCode] = useState('');
    const [cashoutSuccess, updateCashoutSuccess] = useState(false);
    const [cashoutMessageTitle, setCashoutMessageTitle] = useState('');
    const [cashoutMessage, setCashoutMessage] = useState('');

    let ionSlider;
    
    useEffect(() => {

        updateSliderFromInput();

    }, [cashoutAmount])

    const onChangeSlider = () => {

        setCashoutAmount(ionSlider.ionSliderRange.result.from);

    };

    const onChangeInput = (e) => {

        setCashoutAmount(formatCashoutAmount(e.target.value));

    };

    const onChangeCashoutCode = (e) => {

        setCashoutCode(e.target.value);

    }

    const decrementInputAmount = () => {

        let newCashoutAmount = cashoutAmount - 1;
        if (newCashoutAmount < 0){
            return;
        }
        setCashoutAmount(newCashoutAmount);

    };

    const incrementInputAmount = () => {

        let newCashoutAmount = cashoutAmount + 1;
        if (newCashoutAmount > cashoutMaxAmount){
            return;
        }
        setCashoutAmount(newCashoutAmount);

    };

    const updateSliderFromInput = () => {
        ionSlider.update({from: cashoutAmount});
    };

    const formatCashoutAmount = (amount) => {
        return parseFloat((parseFloat(amount)).toFixed(2))
    };

    const confirmCashoutCode = (e) => {
        e.preventDefault();
        e.currentTarget.disabled = true;
        processCashoutAmount();
    };

    const processCashoutAmount = async () => {
        const currentCashoutAmount = await fetchCashoutNowAmount(betSlipId);
        const payload = {
            countedDown: false,
            customerAcceptedAmountChange: false,
            requestedAmount: cashoutAmount
        };
        let response;
        
        if (cashoutAmount > currentCashoutAmount) {
            setCashoutFaild('cashout_errorOnFetchCurrentCashoutAmount');
            toggleShowConfirmationModal();
            setNextStep(2);
            return;
        } else if (cashoutAmount < currentCashoutAmount) {
            response = await cashoutPartialMarkForWithdraw(betSlipId, cashoutCode, payload);
        } else if (cashoutAmount == currentCashoutAmount){
            response = await cashoutFullMarkForWithdraw(betSlipId, cashoutCode, payload);
        } 

        if (response && response.success) {
            setCashoutSuccess();
        } else {
            setCashoutFaild(response.messageKey);
        }

        toggleShowConfirmationModal();
        setNextStep(2);
    };

    const setCashoutSuccess = () => {
        setCashoutMessageTitle('cashout_cashoutSuccessTitleOnFullCashoutNow');
        setCashoutMessage('cashout_cashoutSuccessOnFullCashoutNow');
        updateCashoutSuccess(true); 
        app.component.CheckBetSlip.selector.cashoutNow().addClass('notVisible');
        app.component.CheckBetSlip.selector.partialCashout().addClass('notVisible');
        $('.value.possibleCashout').addClass('hidden');
        $('.cashoutDisclaimer').addClass('hidden');
    };

    const setCashoutFaild = (errorTranslationKey) => {
        setCashoutMessageTitle('cashout_cashoutErrorTitleOnFullCashoutNow');
        setCashoutMessage(errorTranslationKey);
        updateCashoutSuccess(false);
    };

    return (
        <S.CashoutForm> 

            <ModalOpacity isOpen={showConfirmationModal}
                    toggleOpen={toggleShowConfirmationModal}
                    showHeaderIcon={false}
                    showHeaderTitle={true}
                    padding="0px"
                    title={translation('betSlipCheck_cashoutCode')}
                    showCloseIcon={false}>

                <S.CashoutConfirmationPanel>

                    <S.CashoutConfirmationCodeInput value={cashoutCode} autoComplete="off" onChange={onChangeCashoutCode}></S.CashoutConfirmationCodeInput>
                    <S.RowButtons>
                        <S.CashoutCodeButton onClick={toggleShowConfirmationModal}>
                            { translation("common_close") }
                        </S.CashoutCodeButton> 
                        <S.CashoutCodeButton onClick={ confirmCashoutCode }> 
                            { translation("common_confirm") }
                        </S.CashoutCodeButton>
                    </S.RowButtons>
                    
                </S.CashoutConfirmationPanel>

            </ModalOpacity>


			{step == 1 && (

            <>
                <S.CashoutHeader>
                    { translation("common_cashout") }
                </S.CashoutHeader>
                <S.CashoutMainPanel>

                    <S.CashoutAmountLabel>
                        { translation("cashout_cashoutAmount") }
                    </S.CashoutAmountLabel>

                    <S.CashoutSlider>
                        <IonRangeSlider  
                            type={"single"} 
                            skin={"round"}
                            force_edges={true} 
                            min={0.1} 
                            max={cashoutMaxAmount} 
                            from={parseFloat(cashoutAmount)} 
                            to={0.1} step={0.01}  
                            grid={true} 
                            grid_num={5} 
                            hide_min_max={true} 
                            hide_from_to={true} 
                            ref={r => ionSlider = r}
                            onFinish={onChangeSlider} />
                    </S.CashoutSlider>

                    <S.InputWrapper>
                        <S.CashoutStakeButton className="decrement" onClick={decrementInputAmount}></S.CashoutStakeButton>
                        <S.CashoutStakeInput type="number" id="cashoutRange" autoComplete="off" value={cashoutAmount} onChange={onChangeInput}></S.CashoutStakeInput>
                        <S.CashoutStakeButton className="increment"  onClick={incrementInputAmount}></S.CashoutStakeButton>
                    </S.InputWrapper>
                
                    <S.RowButtons> 
                        <S.ActionButton className="close-btn" onClick={() => app.modal.Cashout.hide()}>
                            { translation("common_close") }
                        </S.ActionButton> 
                        <S.ActionButton className="cashout-now-btn" onClick={() => toggleShowConfirmationModal()}> 
                            { translation("betSlipCheck_cashoutNow") }
                        </S.ActionButton>
                    </S.RowButtons>
                </S.CashoutMainPanel>
            </>

			)}

			{step == 2 && (
                <S.CashoutMessagePanel>
                    <S.CashoutStatusIcon className={ (cashoutSuccess ? 'cashout-success':'cashout-failed') }></S.CashoutStatusIcon>

                    <S.CashoutHeaderMessage> { translation(cashoutMessageTitle) } </S.CashoutHeaderMessage>
                    <S.CashoutMainMessage> { translation(cashoutMessage) } </S.CashoutMainMessage>

                    <S.RowButtons className="center"> 
                        <S.ActionButton className={ (cashoutSuccess ? 'cashout-success':'cashout-failed')  }  onClick={() => app.modal.Cashout.hide()}>
                            { translation("common_close") }
                        </S.ActionButton> 
                    </S.RowButtons>
                </S.CashoutMessagePanel>
			)}

        </S.CashoutForm>
    );
};


const mapDispatchToProps = (dispatch) => {
    const actionsToBind = { fetchCashoutNowAmount, cashoutPartialMarkForWithdraw, cashoutFullMarkForWithdraw};
    return {
        ...bindActionCreators(actionsToBind, dispatch)
    }
};

const mapStateToProps = () => {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(CashoutForm);